export const AgencyCenterRoutes = [{
  path: '/AgencyCenter',
  component: () => import('./AgencyCenter.vue'),
  meta: {
    crumbName: '机构中心',
  },
  children: [
    {
      path: 'agencyInfo',
      name: '机构资料编辑',
      component: () => import('../agencyInfo.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:true
      }
    }, {
      path: 'agencyDetail',
      name: '机构资料详情',
      component: () => import('../agencyDetail.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:true
      }
    }, {
      path: 'evaluationInfo/',
      name: '机构中心-测评信息',
      component: () => import('../evaluationInfo.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:true
      }
    }, {
      path: 'evaluationRelease',
      name: '测评-发布中',
      component: () => import('../evaluationRelease.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:true,
        //页面是否需要缓存
        // keepAlive:true
      }
    },
    {
      path: 'oddEvaluationRelease',
      name: '测评-已发布',
      component: () => import('../oddEvaluationRelease'),
      meta: {
        //标明是否需要登录后才能访问
        auth:true,
      }
    },{
      path: 'videoCourse',
      name: '视频课程-发布中',
      component: () => import('../videoCourse.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:true,
      }
    },{
      path: 'oddVideoCourse',
      name: '视频课程-已发布',
      component: () => import('../oddVideoCourse'),
      meta: {
        //标明是否需要登录后才能访问
        auth:true,
      }
    },{
      path: 'addCourse',
      name: '视频课程-上传课程',
      component: () => import('../addCourse.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:true
      }
    }, {
      path: 'registrationRelease',
      name: '测评报名-我报名的',
      component: () => import('../registrationRelease.vue'),
      meta: {
        //页面是否需要缓存
        // keepAlive:true
      }

    },{
      path: 'evaluationResults',
      name: '测评报名-测评成绩查询',
      component: () => import('../evaluationResults'),
      meta: {
        //页面是否需要缓存
        // keepAlive:true
      }

    }, {
      path: 'score',
      name: '测评报名-测评成绩查询',
      component: () => import('../scoreSearch.vue')
    }, {
      path: 'courseUser',
      name: '视频课程-查看报名信息列表',
      component: () => import('../courseUser.vue')
    }, {
      path: 'batchGive',
      name: '视频课程-批量赠送',
      component: () => import('../batchGive.vue')
    }, {
      path: 'viewRegistration',
      name: '测评报名-查看报名信息列表',
      component: () => import('../viewRegistration.vue'),
      // meta: {
      //   //页面是否需要缓存
      //   keepAlive:true
      // }
    }, {
      path: 'activityRelease',
      name: '活动发布-发布中',
      component: () => import('../activityRelease.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:true,
        //页面是否需要缓存
        // keepAlive:true
      }
    }, {
      path: 'oddActivityRelease',
      name: '活动发布-已发布',
      component: () => import('../oddActivityRelease'),
      meta: {
        //标明是否需要登录后才能访问
        auth:true,
        //页面是否需要缓存
        // keepAlive:true
      }
    }, {
      path: 'addActivity',
      name: '发布活动信息',
      component: () => import('../addActivity.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:true
      }
    }, {
      path: 'teacherManage',
      name: '教师/学员管理',
      component: () => import('../teacherManage.vue'),
       meta: {
         //标明是否需要登录后才能访问
         auth:true,
         //页面是否需要缓存
         // keepAlive:true
       }
    },{
      path: 'studentManage',
      name: '学生列表',
      component: () => import('../studentManage'),
      meta: {
        //标明是否需要登录后才能访问
        auth:true,
        //页面是否需要缓存
        // keepAlive:true
      }
    }, {
      path: 'addTeacher',
      name: '新增授课老师',
      component: () => import('../addTeacher.vue'),
       meta: {
         //标明是否需要登录后才能访问
         auth:true
       }
    }, {
      path: 'addStudent',
      name: '新增关联学员',
      component: () => import('../addStudent.vue'),
       meta: {
         //标明是否需要登录后才能访问
         auth:true
       }
    }, {
      path: 'activityRegistration',
      name: '活动报名',
      component: () => import('../activityRegistration.vue'),
       meta: {
         //标明是否需要登录后才能访问
         auth:true
       }
    }, {
      path: 'downloadMy',
      name: '测评记录下载',
      component: () => import('../downloadMy.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:true
      }
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/pages/AgencyCenter/router/AgencyCenter.routes.js